// extracted by mini-css-extract-plugin
export default {"Map":"mapOfStores_Map_Cfstk"};